import { render, staticRenderFns } from "./financialbill.vue?vue&type=template&id=5ffe818e&scoped=true"
import script from "./financialbill.vue?vue&type=script&lang=js"
export * from "./financialbill.vue?vue&type=script&lang=js"
import style0 from "./financialbill.vue?vue&type=style&index=0&id=5ffe818e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe818e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VIcon})
